function SuscripcionCard({ suscripcion, onEliminar }) {
  return (
    <div style={estilos.tarjeta}>
      <div style={estilos.fila}>
        <span style={estilos.nombre}>{suscripcion.nombre}</span>
        <span style={estilos.precio}>
          {Number(suscripcion.coste_mensual).toFixed(2)} {suscripcion.moneda}/mes
        </span>
      </div>
      <div style={estilos.instruccion}>
        {suscripcion.instruccion_heredero || 'Sin instrucciones'}
      </div>
      <div style={estilos.pieFila}>
        <span style={{
          ...estilos.badge,
          backgroundColor: suscripcion.activa ? '#F0F4E8' : '#FDF0EC',
          color: suscripcion.activa ? '#3D4D1F' : '#8B2E0F',
        }}>
          {suscripcion.activa ? 'Activa' : 'Inactiva'}
        </span>
        <button
          onClick={() => onEliminar(suscripcion.id)}
          style={estilos.btnEliminar}
        >
          Eliminar
        </button>
      </div>
    </div>
  )
}

const estilos = {
  tarjeta: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '18px 20px',
    marginBottom: '10px',
    border: '1px solid #E8E0D5',
  },
  fila: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '6px',
  },
  nombre: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#2C1810',
  },
  precio: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#5C6B3A',
  },
  instruccion: {
    fontSize: '13px',
    color: '#8B6F47',
    marginBottom: '12px',
  },
  pieFila: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  badge: {
    fontSize: '11px',
    padding: '3px 10px',
    borderRadius: '20px',
    fontWeight: '500',
  },
  btnEliminar: {
    fontSize: '12px',
    color: '#8B2E0F',
    backgroundColor: 'transparent',
    border: '1px solid #8B2E0F',
    padding: '4px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
}

export default SuscripcionCard